// Every route literal this module owns. The org-wide entry to a domain lives here; the
// service-scoped one (under the CDN service route) belongs to the CDN console that mounts it.
export const ravenPaths = {
  base: '/services/domains',
  newDomain: '/services/domains/new',
  domain: (id: string | number | undefined) => `/services/domains/${id}`,
};
